import { render, staticRenderFns } from "./openLinkModal.vue?vue&type=template&id=9556f570&scoped=true&"
import script from "./openLinkModal.vue?vue&type=script&lang=js&"
export * from "./openLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./openLinkModal.vue?vue&type=style&index=0&id=9556f570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9556f570",
  null
  
)

export default component.exports